import { useContext } from "react";
import { hobbiesActionTypes } from "../reducer/resume-hobbies-reducer";
import { ResumeContext } from "../resume-context";

function useResumeHobbiesHandlers() {
    const { dispatch } = useContext( ResumeContext );
    return {
        handleAdd: () => {
            dispatch( {
                type: hobbiesActionTypes.ADD_HOBBY,
                item: {
                    order: -1,
                    text: ''
                },
            } );
        },
        handleChange: ( hobby ) => {
            dispatch( {
                type: hobbiesActionTypes.CHANGE_HOBBY,
                item: hobby,
            } );
        },
        handleRemove: ( hobby ) => {
            dispatch( {
                type: hobbiesActionTypes.REMOVE_HOBBY,
                item: hobby,
            } );
        },
        handleMoveUp: ( hobby ) => {
            dispatch( {
                type: hobbiesActionTypes.MOVE_HOBBY_UP,
                item: hobby,
            } );
        },
        handleMoveDown: ( hobby ) => {
            dispatch( {
                type: hobbiesActionTypes.MOVE_HOBBY_DOWN,
                item: hobby,
            } );
        },
    }
}

export default useResumeHobbiesHandlers
